import {
  DEFAULT_QC_REASON_BORDER_COLOR,
  DEFAULT_QC_REASON_BORDER_SIZE,
  QC_REASON_FAILED_BORDER_COLOR,
  QC_REASON_PASSED_BORDER_COLOR,
  QC_REASON_PASSED_OR_FAILED_BORDER_SIZE,
} from 'components/Modals/constants';
import {
  isQCScoreFailed,
  isQCScorePassed,
} from 'components/ImageViewer/utilities';
import { isGLPSlide } from 'utilities/slides';

export const checkIfFailedQC = (qcChecks) =>
  Object.values(qcChecks).some((value) => value);

export const getQCReasonCheckBoxBorderProps = (modelScore, isGLP = false) => {
  let borderColor = DEFAULT_QC_REASON_BORDER_COLOR;
  let borderSize = DEFAULT_QC_REASON_BORDER_SIZE;

  if (isGLP) {
    return {
      borderColor,
      borderSize,
    };
  }

  if (isQCScorePassed(modelScore) && modelScore !== null) {
    borderColor = QC_REASON_PASSED_BORDER_COLOR;
    borderSize = QC_REASON_PASSED_OR_FAILED_BORDER_SIZE;
  } else if (isQCScoreFailed(modelScore)) {
    borderColor = QC_REASON_FAILED_BORDER_COLOR;
    borderSize = QC_REASON_PASSED_OR_FAILED_BORDER_SIZE;
  }

  return {
    borderColor,
    borderSize,
  };
};

export const prepareUtilsVariables = (slide, currentQcScoreDisplay) => {
  const isGLP = isGLPSlide(slide);

  const ROI = slide?.order?.region_of_interest;

  const modalSlideID = `${slide.uuid}-modal`;

  const isShowModelOverlayEnabled = !isGLP && currentQcScoreDisplay !== null;

  const slideDetailsSampleInfo = slide.sample?.name
    ? ` - Sample: ${slide.sample?.name}`
    : '';
  const slideDetailsTitle = `Details: ${slide.order?.name}${slideDetailsSampleInfo}`;
  const specialInstructionsAccordionTitle = `Special Instructions for ${slide.order?.name}`;

  return {
    isGLP,
    ROI,
    modalSlideID,
    isShowModelOverlayEnabled,
    slideDetailsSampleInfo,
    slideDetailsTitle,
    specialInstructionsAccordionTitle,
  };
};
